module.exports = __webpack_public_path__ + "static/img/daojishuawen.41003cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pub_img/daojishuawen.png
// module id = raUd
// module chunks = 46